import React, { useState } from "react";
import { Tabs, Tab, Paper, Typography, Box } from "@material-ui/core";
import DrugIDDetails from "./DrugIDDetails"; // Import the DrugIDDetails component

const ForecastScheduleIndex = () => {
  const [selectedTab, setSelectedTab] = useState(1); // Start with Drug ID tab

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="Quantity" disabled />
        <Tab label="Drug ID" />
        {/* <Tab label="Approvals" disabled /> */}
        <Tab label="Analytics & MIS" disabled />
      </Tabs>
      <Paper style={{ padding: "20px" }}>
        {/* Tabs for navigation */}

        {/* Content corresponding to the selected tab */}
        <Box p={2}>
          {selectedTab === 1 && <DrugIDDetails />}
          {selectedTab !== 1 && (
            <Typography
              variant="body1"
              style={{ textAlign: "center", marginTop: "20px" }}
            >
              Please select the "Drug ID" tab to view the details.
            </Typography>
          )}
        </Box>
      </Paper>
    </>
  );
};

export default ForecastScheduleIndex;
